import React, { Component } from 'react';
import { connect } from 'react-redux';
import Row from '../../../../../common/grid/Row.js';
import Col from '../../../../../common/grid/Col.js';
import Button from '../../../../../common/button/Button.js';
import Input from '../../../../../common/input/Input.js';
import { validate } from "../../../../../helpers/validate.js";

// Actions
import { setErrors, clearErrors } from '../../../../../actions/error.js';
import { createFolder } from "../../../../../actions/folder.js";

import '../../add/AddGfaDocument.css';

class AddGfaFolder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      file: '',
      navigationBlocked: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleInputChange(text, name) {
    this.setState({ [name]: text });
  }

  validate() {
    const checkAgainst = ['name'];

    const errors = validate(this.state, checkAgainst);
    this.props.addErrors(errors);

    return Object.keys(errors).length === 0;
  }

  onSubmitClick(e) {
    e.preventDefault();

    if (this.validate()) {
      // navigation is not blocked anymore
      this.setState({ navigationBlocked: false });

      const folder = {
        name: this.state.name
      };

      this.props.emptyErrors();
      this.props.createFolder(folder);
      alert('Folder has been added!');
    }
  }

  componentWillUnmount() {
    this.setState({
      name: '',
      file: null
    });

    if (this.state.navigationBlocked) {
      alert("You've navigated away. All changes destroyed!");
    }
  }

  render() {
    return (
      <div className='add-gfa-document'>
        <h2>Add Folder</h2>
        <Col _bottom-8>
          <Row>
            <Input
              ph='Name'
              name='name'
              value={this.state.name}
              onChange={this.handleInputChange}
            />
          </Row>
          <Row _space-between>
            <Button className="btn-green btn-square" onClick={this.onSubmitClick}>Save</Button>
          </Row>
        </Col>
      </div >
    );
  }
}

const mapDispatchToProps = {
  addErrors: (errors) => dispatch => dispatch(setErrors(errors)),
  emptyErrors: () => dispatch => dispatch(clearErrors()),
  createFolder
}

export default connect(null, mapDispatchToProps)(AddGfaFolder);


// WEBPACK FOOTER //
// ./src/components/main/gfa-documents/folders/add/AddGfaFolder.js